import React from "react";
import {Link} from "react-router-dom";
import {
    FormControl,
    IconButton,
    InputLabel,
    makeStyles,
    Typography
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableContainer
    from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {Delete, Edit, DragHandle as DragHandleIcon} from "@material-ui/icons";
import {
    useGlobalFilter,
    usePagination,
    useRowSelect,
    useTable,
} from "react-table";
import {
    CustomCheckbox,
    formatDatetime,
    modal
} from "../../../util";
import {useLoading} from "../../../util/LoadingProvider";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import apiHelper from "../../../util/ApiHelper";
import {toast} from "react-toastify";
import PaginationBar from "../../common/PaginationBar";
import {DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";

const useStyles = makeStyles((theme) => ({
    textInput: {
        backgroundColor: "white",
        width: "100%",
        marginBottom: "12px",

        "& input": {
            fontSize: "14px",
        },
    },
    content: {
        "& .ck-editor__editable_inline": {
            minHeight: "200px",
        },
    },
    text: {
        textDecoration: "none",
        color: "#306F9D",
    },
    inactive: {
        color: "#999999",
    },
    buttonGroup: {
        marginTop: "20px",
        textAlign: "right",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    box: {
        padding: 0,
        background: "#ffffff",
        paddingTop: "10px",
        paddingBottom: "10px",
        minHeight: "800px",
    },
    innerBox: {
        background: "#ffffff",
        padding: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
    button: {
        backgroundColor: "#306F9D",
        textTransform: "capitalize",
        color: "white",
        "&:hover": {
            backgroundColor: "#306F9D",
        },
    },
    pagination: {
        "& .MuiTextField-root": {
            width: "35px",
            minWidth: "auto",
        },
        "& .MuiSelect-root": {
            paddingTop: "3px",
            paddingBottom: "3px",
        },
        "& input": {
            padding: "4px 0",
            marginLeft: "10px",
            marginRight: "10px",
        },
        "& button": {
            background: "white",
            color: "#cccccc",
            border: "1px solid #CCCCCC",
            minWidth: "auto",
            width: "24px",
            height: "24px",
            margin: "4px 0",
            "&.left": {
                borderRadius: "4px 0 0 4px",
                marginLeft: "10px",
            },
            "&.right": {
                borderRadius: " 0 4px 4px 0",
            },
        },
    },
}));


const IsDraggingContext = React.createContext(false);


const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};


class DraggableTableCell extends React.Component {
    getSnapshotBeforeUpdate(prevProps) {
        if (!this.ref) return null;

        const isDragStarting =
            this.props.isDragOccurring && !prevProps.isDragOccurring;

        if (!isDragStarting) return null;

        const {width, height} = this.ref.getBoundingClientRect();
        return {width, height};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const ref = this.ref;
        if (!ref) return;

        if (snapshot) {
            if (ref.style.width === snapshot.width) return;
            ref.style.width = `${snapshot.width}px`;
            ref.style.height = `${snapshot.height}px`;
            return;
        }

        if (this.props.isDragOccurring) return;

        if (ref.style.width == null) return;

        ref.style.removeProperty("height");
        ref.style.removeProperty("width");
    }

    setRef = (ref) => {
        this.ref = ref;
    };

    render() {
        return (
            <TableCell
                style={{paddingTop: 6, paddingBottom: 6, lineHeight: "1.1em", height: "48px"}}
                ref={this.setRef}
                align={this.props.align}
                className={this.props.className}
            >
                {this.props.children}
            </TableCell>
        );
    }
}

// table row
const DraggableTableRow = ({
                                snapshot,
                                row,
                                provided,
                                orderingDisabled,
                                isDragging,
                            }) => {
    return (
        <TableRow
            ref={provided.innerRef}
            {...provided.draggableProps}
            style={{
                ...provided.draggableProps.style,
                background: snapshot.isDragging ? "#f5f5f5" : "white",
            }}
        >
            {row.cells.map((cell, index) => {
                return index !== row.cells.length - 1 && (
                    <DraggableTableCell
                        key={index}
                        isDragOccurring={isDragging}
                        className={cell.column.className}
                    >
                        {cell.render("Cell")}
                    </DraggableTableCell>
                );
            })}

            <TableCell
                style={{paddingTop: 6, paddingBottom: 6, lineHeight: "1.1em", height: "48px", color: "#CCCCCC", cursor: "grab"}}
                {...(!orderingDisabled && {...provided.dragHandleProps})}
            >
                <DragHandleIcon/>
            </TableCell>
        </TableRow>
    );
};

const IndeterminateCheckbox = React.forwardRef(
    ({indeterminate, ...rest}, ref) => {
        const defaultRef = React.useRef();
        const resolvedRef = ref || defaultRef;

        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate;
        }, [resolvedRef, indeterminate]);

        return <CustomCheckbox type="checkbox"
                               ref={resolvedRef} {...rest} />;
    }
);

function TicketListingPage(props) {
    const {match, disabled} = props;
    const classes = useStyles();
    const [data, setData] = React.useState([]);
    const [keyword, setKeyword] = React.useState("");
    const [queryString, setQueryString] = React.useState("");
    const [actionType, setActionType] = React.useState("");
    const [totalPages, setTotalPages] = React.useState(0);
    const {setLoading} = useLoading();

    // for pagination
    const [page, setPage] = React.useState(0);
    // const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [totalElements, setTotalElements] = React.useState(0);


    const [isDragging, setIsDragging] = React.useState(false);
    const [orderingDisabled, setOrderingDisabled] = React.useState(false);

    const CustomLink = React.useMemo(
        () =>
            React.forwardRef((linkProps, ref) => <Link
                ref={ref} {...linkProps} />),
        []
    );

    const handleSelectChange = (e) => {
        setActionType(e.target.value);
    };

    const handleBulkAction = React.useCallback(async () => {
        switch (actionType) {
            case "DELETE":
                try {
                    let ids = [];
                    let deleteCount = 0;
                    for (var i = 0; i < rows.length; i++) {
                      if (rows[i].isSelected) {
                        ids.push(rows[i].original.id);
                        deleteCount++;
                      }
                    }
                    const decision = await modal.fire({
                      title: "Delete Tickets",
                      text: `Are you sure to delete ${deleteCount} ticket(s)?`,
                      showCancelButton: true,
                      confirmButtonText: `Delete`,
                    });
                    if (deleteCount > 0 && decision.isConfirmed) {
                      try {
                        const promises = ids.map((id) =>
                          apiHelper.hkiff.deleteTicketing(id)
                        );
                        const results = await Promise.all(promises);
                        console.log(results);
                        toast.dark(`${ids.length} ticket(s) deleted.`);
                        getTickets();
                      } catch (err) {
                        console.log(err);
                      }
                    }
                  } catch (err) {
                    console.log(err);
                  }
                  return;
            default:
                break;
        }
    }, [actionType]);

    const deleteTicket = async (id) => {
        const decision = await modal.fire({
            title: "Delete Ticket",
            text: "Are you sure to delete this ticket?",
            showCancelButton: true,
            confirmButtonText: `Delete`,
        });
        if (decision.isConfirmed) {
            try {
                const result = await apiHelper.hkiff.deleteTicketing(id);
                if (result.data.code === 0) {
                    toast.dark("Ticket deleted.");
                    await getTickets();
                }
            } catch (err) {
                console.log(err);
            }
        }
    };

    const triggerSearch = React.useCallback(() => {
        setQueryString(keyword);
        setOrderingDisabled(keyword ? true : false);
    }, [keyword]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const onBeforeDragStart = React.useCallback(() => {
        setIsDragging(true);
    }, []);

    const onDragEnd = React.useCallback((result) => {
        setIsDragging(false);

        if (!result.destination) {
            return;
        }

        const items = reorder(
            data,
            result.source.index,
            result.destination.index
        );

        console.log("Reordered:", items);
        setData(items);
    }, [data]);

    const saveOrdering = async () => {
        try {
            const newArray = data.map((item, index) => ({
                id: item.id,
                sequence: index + pageSize * pageIndex,  // 计算全局序号
            }));

            console.log("Saving sequences:", newArray);

            // call API
            const result = await apiHelper.hkiff.updateTicketingSeq(newArray);

            if (result.data.code === 0) {
                toast.dark("Your changes are saved.");
                // reload data
                getTickets();
            } else {
                toast.error("Failed to save changes.");
            }
        } catch (err) {
            console.error("Save ordering error:", err);
            toast.error("An error occurred while saving.");
        }
    };

    // const handleChangeRowsPerPage = (event) => {
    //     if (event.target.value > 0) {
    //         setRowsPerPage(parseInt(event.target.value, 10));
    //         setPage(0);
    //     } else {
    //         getTickets();
    //         setRowsPerPage(parseInt(event.target.value, 10));
    //         setPage(0);
    //     }
    // };

    const columns = React.useMemo(
        () => [
            {
                Header: "Name (English)",
                accessor: "titleEn",
                Cell: ({row}) => {
                    return (
                        <Link
                            to={`${match.url}/${row.original.id}`}
                            className={classes.text}
                        >
                            {row.original.titleEn ? row.original.titleEn : '-'}
                        </Link>
                    );
                },
            },
            {
                Header: "Name (Traditional)",
                accessor: "titleTc",
                Cell: ({row}) => {
                    return (
                        <Link
                            to={`${match.url}/${row.original.id}`}
                            className={classes.text}
                        >
                            {row.original.titleTc ? row.original.titleTc : '-'}
                        </Link>
                    )
                },
            },
            {
                Header: "Url Ext Name",
                accessor: "urlExtName",
                Cell: ({row}) => {
                    return row.original.urlExtName ? `$${row.original.urlExtName}` : '-';
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({row}) => {
                    switch (row.original.status) {
                        default:
                        case "INACTIVE":
                            return <span
                                className={classes.text}>Inactive</span>
                        case "ACTIVE":
                            return <span
                                className={classes.text}>Active</span>
                    }
                },
            },
            {
                Header: "Last Update",
                accessor: "updateTime",
                disableGlobalFilter: true,
                Cell: ({row}) => {
                    return row.original.updateTime ? formatDatetime(row.original.updateTime) : '-';
                },
            },
        ],
        []
    );


    const {
        getTableProps,
        headerGroups,
        getTableBodyProps,
        state: {pageIndex, pageSize},
        rows,
        prepareRow,
        setPageSize,
        gotoPage,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        selectedFlatRows,
        setGlobalFilter,
    } = useTable(
        {
            columns,
            data,
            manualPagination: true,
            autoResetPage: false,
            pageCount: totalPages,
        },
        useGlobalFilter,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => [
                // Let's make a column for selection
                {
                    id: "selection",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: ({getToggleAllRowsSelectedProps}) => (
                        <div>
                            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                        </div>
                    ),
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({row}) => (
                        <div>
                            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                        </div>
                    ),
                },
                ...columns,
                {
                    id: "action",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: () => <div>Action</div>,
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({row}) => (
                        <div
                            style={{display: "inline-flex"}}>
                            <IconButton
                                className={classes.iconBtn}
                                size="small"
                                component={CustomLink}
                                to={`${match.url}/${row.original.id}`}
                            >
                                <Edit fontSize="small"/>
                            </IconButton>
                            {!disabled && (
                                <IconButton
                                    className={classes.iconBtn}
                                    size="small"
                                    onClick={() => {
                                        deleteTicket(row.original.id);
                                    }}
                                >
                                    <Delete
                                        fontSize="inherit"/>
                                </IconButton>
                            )}
                        </div>
                    ),
                },
                // drag col
                {
                    id: "dragHandle",
                    Header: () => <></>,  // empty col
                },
            ]);
        }
    );

    const getTickets = React.useCallback(async () => {
        setLoading(true);
        try {
            const results = await apiHelper.hkiff.getTicketing({
                keyword: queryString,
                page: pageIndex,
                size: pageSize
            });
            console.log('RESULTS:', results);
            setData(results.data.content);
            setTotalElements(results.data.totalElements)
            setTotalPages(Math.ceil(results.data.totalElements / pageSize));
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }, [pageIndex, pageSize, queryString, setLoading]);

    React.useEffect(() => {
        getTickets();
    }, [getTickets])

    return (
        <div className={classes.content}>
            <Typography variant="h4" gutterBottom>
                Ticket & FAQ &gt; Ticketing Info
            </Typography>
            <Grid
                container
                justify="space-between"
                style={{paddingBottom: "10px"}}
            >
                <Grid container item xs={6}>
                    <Grid container item xs={3}>
                        <FormControl fullWidth
                                     margin="dense"
                                     variant="outlined">
                            <InputLabel
                                id="demo-simple-select-outlined-label">
                                Bulk Actions
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={actionType}
                                onChange={handleSelectChange}
                                label="Bulk Actions"
                                disabled={disabled}
                            >
                                <MenuItem value={"NONE"}>
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem
                                    value={"DELETE"}>Delete</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid container item xs={2}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleBulkAction}
                            disabled={disabled}
                        >
                            Apply
                        </Button>
                    </Grid>
                </Grid>
                <Grid container item xs={6}>
                    <Box
                        width="100%"
                        component="span"
                        display="flex"
                        justifyContent="flex-end"
                        alignItems="center"
                    >
                        <Box display="flex" style={{marginRight: "10px"}}>
                            <Button
                                variant="contained"
                                color="primary"
                                type="button"
                                onClick={saveOrdering}
                                disabled={orderingDisabled || disabled}
                            >
                                Save Changes
                            </Button>
                        </Box>
                        <Box display="flex" style={{marginRight: "10px"}}>
                            <Button
                                variant="contained"
                                color="primary"
                                type="button"
                                component={Link}
                                disabled={disabled}
                                to={`${match.url}/new`}
                            >
                                Add Ticket
                            </Button>
                        </Box>
                        <Box display="flex">
                            <TextField
                                id="outlined-error"
                                label="Search Ticket"
                                variant="outlined"
                                margin="dense"
                                value={keyword}
                                onChange={(e) => setKeyword(e.target.value)}
                            />
                        </Box>
                        <Box display="flex">
                            <Button
                                variant="outlined"
                                color="primary"
                                type="button"
                                margin="dense"
                                onClick={triggerSearch}
                            >
                                Search
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Grid container xs={12}>
                <TableContainer
                    component={Paper}
                    style={{
                        boxShadow: "none",
                        border: "1px solid #cccccc",
                    }}
                >
                    <fieldset disabled={disabled}
                              className="fieldset">
                        <Table
                            aria-label="simple table"
                            component="ul"
                            style={{margin: "0"}}
                            {...getTableProps()}
                        >
                            <colgroup>
                                <col
                                    style={{width: "5%"}}/>
                                <col
                                    style={{width: "18%"}}/>
                                <col
                                    style={{width: "18%"}}/>
                                <col
                                    style={{width: "10%"}}/>
                                <col
                                    style={{width: "10%"}}/>
                                <col
                                    style={{width: "15%"}}/>
                                <col
                                    style={{width: "10%"}}/>
                                <col
                                    style={{width: "5%"}}/>
                            </colgroup>
                            <TableHead component="div">
                                {headerGroups.map((headerGroup) => (
                                    <TableRow {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <TableCell
                                                {...column.getHeaderProps()}
                                                className={`${column.className ?? ""}`}
                                                style={{
                                                    paddingTop: 6,
                                                    paddingBottom: 6,
                                                    lineHeight: "1.1em",
                                                    height: "48px",
                                                }}
                                            >
                                                {column.render("Header")}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableHead>
                            <IsDraggingContext.Provider value={isDragging}>
                                <DragDropContext
                                    onBeforeDragStart={onBeforeDragStart}
                                    onDragEnd={onDragEnd}
                                >
                                    <Droppable droppableId="ticketing-droppable">
                                        {(provided, snapshot) => (
                                            <TableBody
                                                component="div"
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                {...getTableBodyProps()}
                                            >
                                                {rows.map((row, index) => {
                                                    prepareRow(row);
                                                    return (
                                                        <Draggable
                                                            key={row.original.id}
                                                            draggableId={String(row.original.id)}
                                                            index={index}
                                                            isDragDisabled={disabled || orderingDisabled}
                                                        >
                                                            {(provided, snapshot) => (
                                                                <DraggableTableRow
                                                                    key={row.original.id}
                                                                    row={row}
                                                                    provided={provided}
                                                                    snapshot={snapshot}
                                                                    orderingDisabled={orderingDisabled}
                                                                    isDragging={isDragging}
                                                                />
                                                            )}
                                                        </Draggable>
                                                    );
                                                })}
                                                {provided.placeholder}
                                            </TableBody>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </IsDraggingContext.Provider>
                        </Table>
                    </fieldset>
                </TableContainer>
            </Grid>
            <Grid
                container
                spacing={12}
                justify="space-between"
                alignItems="center"
            >
                <Grid container item xs={12}
                      justify="flex-end">
                    <PaginationBar
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        gotoPage={gotoPage}
                        previousPage={previousPage}
                        nextPage={nextPage}
                        canPreviousPage={canPreviousPage}
                        canNextPage={canNextPage}
                        pageIndex={pageIndex}
                        totalCount={totalElements}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export default TicketListingPage;
